import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24e21b40")

_pushScopeId("data-v-24e21b40")
const _hoisted_1 = { class: "signup-privacy-policy" }
const _hoisted_2 = { class: "signup-privacy-policy__content" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "agree1",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Согласие на сбор и использование персональных данных "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(обязательно)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"-medium\" data-v-24e21b40><thead data-v-24e21b40><tr data-v-24e21b40><th data-v-24e21b40>Цель</th><th data-v-24e21b40>Данные</th><th data-v-24e21b40>Продолжительность</th></tr></thead><tbody data-v-24e21b40><tr data-v-24e21b40><td data-v-24e21b40><span data-v-24e21b40>Идентификация и управление пользователями</span></td><td data-v-24e21b40><span data-v-24e21b40>Электронная почта, ФИО, номер мобильного телефона, пол </span></td><td data-v-24e21b40><span data-v-24e21b40>Удаляется сразу после удаления учетной записи</span></td></tr></tbody></table>", 1)
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agree2",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Согласие на использование видеоизображения во время видеоконсультации "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(обязательно) ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " Для удобства выписывания рецептов изображения повреждений, ран и т.д. могут быть сохранены для диагностики врачом во время видеоконсультации и не будут использоваться для каких-либо других целей, кроме выписывания рецептов. ", -1)
const _hoisted_12 = { class: "agree" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "agree3",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Прочитать и согласиться с условиями регистрации "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(обязательно)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ps" }, [
  /*#__PURE__*/_createVNode("span", null, "Ответственность за введение в заблуждение или кражу персональных данных"),
  /*#__PURE__*/_createVNode("ol", null, [
    /*#__PURE__*/_createVNode("li", null, " 1. Если пользователь при регистрации указывает ложные персональные данные, такие как ФИО, дата рождения и т.д., или похищает персональные данные другого лица, он может быть подвергнут уголовному наказанию в соответствии с действующим законодательством. "),
    /*#__PURE__*/_createVNode("li", null, " 2. Компания и медицинское учреждение не обязаны возмещать участнику ущерб, причиненный использованием услуги, если участник воспользовался услугой путем введения в заблуждение персональных данных или кражи чужого имени, как указано в п. 1. "),
    /*#__PURE__*/_createVNode("li", null, " 3. В случае нанесения ущерба Компании или медицинскому учреждению в результате введения Пользователя в заблуждение или кражи его имени, Пользователь несет ответственность за ущерб перед Компанией и медицинским учреждением. ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            id: "agree1",
            modelValue: _ctx.state.agree1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.agree1 = $event)),
            class: "-royalBlue check-box",
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            id: "agree2",
            modelValue: _ctx.state.agree2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.agree2 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Checkbox, {
            id: "agree3",
            modelValue: _ctx.state.agree3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.agree3 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        _hoisted_15,
        _hoisted_16
      ])
    ])
  ]))
})